// Work experience, from LinkedIn plus Adler One (not listed there).
// Sorted on the About page with ongoing roles first, then by most recent
// end date. Dates use "YYYY-MM", or "YYYY" when the month isn't known;
// end: null means the role is ongoing.
// `arrangement` and `description` are only shown when set.
export const experience = [
	{
		company: "Adler One",
		title: "Head of Product",
		start: "2022",
		end: null,
		arrangement: "Remote",
	},
	{
		company: "uxKraft",
		title: "UX Designer",
		start: "2024-08",
		end: null,
		arrangement: "Remote",
	},
	{
		company: "Youpal Group",
		title: "UX Designer",
		start: "2023-01",
		end: "2024-08",
		arrangement: "Remote",
		description:
			"Improved UX flows and automated manual processes for internal products. Worked closely with the CEO to understand how each department worked.",
	},
	{
		company: "NorthStarPPC",
		title: "WordPress Developer",
		start: "2023-02",
		end: "2023-09",
		arrangement: "Contract",
	},
	{
		company: "Immutus",
		title: "Product Designer",
		start: "2023-02",
		end: "2023-08",
		arrangement: "Contract · Remote",
	},
	{
		company: "Grayhat",
		title: "UI/UX Designer",
		start: "2022-10",
		end: "2023-08",
		arrangement: "Hybrid",
		description:
			"Designed with component libraries and design systems so work translated cleanly into development.",
	},
	{
		company: "Outsourcing",
		title: "UI Designer",
		start: "2022-03",
		end: "2023-01",
		arrangement: "Remote",
		description:
			"Worked with a senior designer on client websites, web apps and online stores, including design systems, client communication and deadlines.",
	},
	{
		company: "Daastan",
		title: "UX Designer",
		start: "2022-03",
		end: "2022-08",
		arrangement: "Internship",
		description:
			"Redesigned the website, online store, and author and admin portals for a book publishing company, working with the CEO to streamline processes.",
	},
];

const MONTHS = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec",
];

export function formatMonth(value) {
	const [year, month] = value.split("-");
	return month ? `${MONTHS[Number(month) - 1]} ${year}` : year;
}

// Ongoing roles first, in the order listed above; then most recent end
// date, with ties going to the later start.
export function sortExperience(items) {
	return [...items].sort((a, b) => {
		if (!a.end && !b.end) return 0;
		const endA = a.end || "9999";
		const endB = b.end || "9999";
		if (endA !== endB) return endB.localeCompare(endA);
		return b.start.localeCompare(a.start);
	});
}
